import { projectFilter, duneDocumentsSelect } from "@dune/vars";
import {
	DashboardTaskWithEntityReferences,
} from "../tasks/tasks.types";
import type { Prisma } from "@prisma/client";
import { ConstructionSiteStatus, GFAStatus } from "../constructionSites/constructionSites.types";
import { PropositionStatusType } from "../propositions/propositions.types";

export type OfferType = typeof OfferType[keyof typeof OfferType];

export const OfferType = {
	DO: "DO",
	TRC: "TRC",
	MRT: "MRT",
	GFA: "GFA",
	RCMO: "RCMO",
	CNR: "CNR",
} as const;

export type ProjectFilterValues = typeof projectFilter[keyof typeof projectFilter];

export interface ReceiptItem {
	id: string;
	title: string;
	amount: number;
	dueDate: string;
	status: "PENDING" | "OVERDUE" | "PAID";
	reference: string;
}

export interface ReceiptsResponse {
	receipts: ReceiptItem[];
	totalCount: number;
	totalAmount: number;
}

export interface TasksResponse {
	tasks: DashboardTaskWithEntityReferences[];
	totalCount: number;
	todoCount: number;
	inProgressCount: number;
}

export interface DocumentsListProps {
	activeFilter: string;
}

export enum DocumentEntityType {
	SOCIETY = "SOCIETY",
	CONSTRUCTION_SITE = "CONSTRUCTION_SITE", 
	CONSTRUCTION_SITE_SUBMISSION = "CONSTRUCTION_SITE_SUBMISSION",
	PARTNERSHIP_ANALYSIS = "PARTNERSHIP_ANALYSIS",
	PROPOSITION = "PROPOSITION"
}

export type DocumentItem = Prisma.FileGetPayload<{
	select: typeof duneDocumentsSelect;
}>;

export type FileWithDocuments = Prisma.FileGetPayload<{
	select: typeof duneDocumentsSelect;
}>;

export interface ConstructionSiteWithClientDetails {
	constructionSiteClientDetails?: {
		clientSociety?: {
			denomination: string;
		} | null;
		constructionSiteClientContacts?: {
			constructionSiteContact: {
				firstname: string;
				lastname: string;
			};
		}[];
	} | null;
}

export interface ProcessedDocumentItem {
	id: string;
	type: "Apporteur" | "Projet" | "Soumission" | "Autre";
	description: string;
	status: string;
	reference: string;
	fileCount: number;
	createdAt: string;
	updatedAt: string;
	dueDate: string;
	entityType: DocumentEntityType;
	entityId: string;
	fileName: string;
	documentType: DocumentEntityType;
	isContract?: boolean;
}

export interface DocumentsResponse {
	documents: ProcessedDocumentItem[];
	totalCount: number;
	categories: {
		apporteurs: number;
		projets: number;
		propositions: number;
		contrats: number;
	};
}

export interface ProjectItem {
	id: number;
	title: string;
	clientName: string;
	status: ConstructionSiteStatus | GFAStatus
	offerTypes: OfferType[];
	createdAt: string;
	updatedAt: string;
	totalAmount: number;
	propositionId?: number;
}

export interface PropositionItem {
	id: number;
	title: string;
	clientName: string;
	status: PropositionStatusType;
	offerTypes: OfferType[];
	createdAt: string;
	updatedAt: string;
	totalAmount: number;
	propositionId?: number;
}

export interface ProjectsResponse {
	projects: {
		inProgress: ProjectItem[];
		propositions: PropositionItem[];
		contracts: PropositionItem[];
		reception: ProjectItem[];
	};
	totalCounts: {
		tous: number;
		do: number;
		trc: number;
		mrt: number;
		gfa: number;
	};
} 

